var map = {
	"./accordion/accordion.module": [
		"./src/app/theme/ui-elements/basic/accordion/accordion.module.ts",
		"accordion.module"
	],
	"./add-on/add-on.module": [
		"./src/app/theme/forms/add-on/add-on.module.ts",
		"add-on.module"
	],
	"./advance-elements/advance-elements.module": [
		"./src/app/theme/forms/advance-elements/advance-elements.module.ts",
		"common",
		"advance-elements.module"
	],
	"./alert/alert.module": [
		"./src/app/theme/ui-elements/basic/alert/alert.module.ts",
		"alert.module"
	],
	"./analytics/analytics.module": [
		"./src/app/theme/dashboard/analytics/analytics.module.ts",
		"common",
		"analytics.module"
	],
	"./basic-color/basic-color.module": [
		"./src/app/theme/ui-elements/basic/basic-color/basic-color.module.ts",
		"basic-color.module"
	],
	"./basic-elements/basic-elements.module": [
		"./src/app/theme/forms/basic-elements/basic-elements.module.ts",
		"basic-elements.module"
	],
	"./basic-invoice/basic-invoice.module": [
		"./src/app/theme/extension/invoice/basic-invoice/basic-invoice.module.ts",
		"basic-invoice.module"
	],
	"./basic-list/basic-list.module": [
		"./src/app/theme/ui-elements/basic/basic-list/basic-list.module.ts",
		"basic-list.module"
	],
	"./basic-login/basic-login.module": [
		"./src/app/theme/auth/login/basic-login/basic-login.module.ts",
		"basic-login.module"
	],
	"./basic-other/basic-other.module": [
		"./src/app/theme/ui-elements/basic/basic-other/basic-other.module.ts",
		"basic-other.module"
	],
	"./basic-reg/basic-reg.module": [
		"./src/app/theme/auth/registration/basic-reg/basic-reg.module.ts",
		"basic-reg.module"
	],
	"./border/border.module": [
		"./src/app/theme/table/bootstrap-table/border/border.module.ts",
		"border.module"
	],
	"./box-shadow/box-shadow.module": [
		"./src/app/theme/ui-elements/basic/box-shadow/box-shadow.module.ts",
		"box-shadow.module"
	],
	"./breadcrumb/breadcrumb.module": [
		"./src/app/theme/ui-elements/basic/breadcrumb/breadcrumb.module.ts",
		"breadcrumb.module"
	],
	"./button/button.module": [
		"./src/app/theme/ui-elements/basic/button/button.module.ts",
		"button.module"
	],
	"./c3-js/c3-js.module": [
		"./src/app/theme/chart/c3-js/c3-js.module.ts",
		"c3-js.module"
	],
	"./carousel/carousel.module": [
		"./src/app/theme/ui-elements/advance/carousel/carousel.module.ts",
		"carousel.module"
	],
	"./chart-js/chart-js.module": [
		"./src/app/theme/chart/chart-js/chart-js.module.ts",
		"common",
		"chart-js.module"
	],
	"./chart-widget/chart-widget.module": [
		"./src/app/theme/widget/chart-widget/chart-widget.module.ts",
		"common",
		"chart-widget.module"
	],
	"./data-widget/data-widget.module": [
		"./src/app/theme/widget/data-widget/data-widget.module.ts",
		"data-widget.module"
	],
	"./default/default.module": [
		"./src/app/theme/dashboard/default/default.module.ts",
		"common",
		"default.module"
	],
	"./ecommerce/ecommerce.module": [
		"./src/app/theme/dashboard/ecommerce/ecommerce.module.ts",
		"common",
		"ecommerce.module"
	],
	"./forgot/forgot.module": [
		"./src/app/theme/auth/forgot/forgot.module.ts",
		"forgot.module"
	],
	"./form-picker/form-picker.module": [
		"./src/app/theme/forms/form-picker/form-picker.module.ts",
		"form-picker.module"
	],
	"./form-select/form-select.module": [
		"./src/app/theme/forms/form-select/form-select.module.ts",
		"common",
		"form-select.module"
	],
	"./form-validation/form-validation.module": [
		"./src/app/theme/forms/form-validation/form-validation.module.ts",
		"form-validation.module"
	],
	"./generic-class/generic-class.module": [
		"./src/app/theme/ui-elements/basic/generic-class/generic-class.module.ts",
		"generic-class.module"
	],
	"./google-chart/google-chart.module": [
		"./src/app/theme/chart/google-chart/google-chart.module.ts",
		"google-chart.module"
	],
	"./google-map/google-map.module": [
		"./src/app/theme/map/google-map/google-map.module.ts",
		"google-map.module"
	],
	"./header-footer-login/header-footer-login.module": [
		"./src/app/theme/auth/login/header-footer-login/header-footer-login.module.ts",
		"header-footer-login.module"
	],
	"./header-footer-reg/header-footer-reg.module": [
		"./src/app/theme/auth/registration/header-footer-reg/header-footer-reg.module.ts",
		"header-footer-reg.module"
	],
	"./invoice-list/invoice-list.module": [
		"./src/app/theme/extension/invoice/invoice-list/invoice-list.module.ts",
		"invoice-list.module"
	],
	"./invoice-summary/invoice-summary.module": [
		"./src/app/theme/extension/invoice/invoice-summary/invoice-summary.module.ts",
		"common",
		"invoice-summary.module"
	],
	"./label-badge/label-badge.module": [
		"./src/app/theme/ui-elements/basic/label-badge/label-badge.module.ts",
		"label-badge.module"
	],
	"./lock-screen/lock-screen.module": [
		"./src/app/theme/auth/lock-screen/lock-screen.module.ts",
		"lock-screen.module"
	],
	"./login/login.module": [
		"./src/app/theme/auth/login/login.module.ts",
		"login.module"
	],
	"./master/master.module": [
		"./src/app/master/master.module.ts"
	],
	"./modal/modal.module": [
		"./src/app/theme/ui-elements/advance/modal/modal.module.ts",
		"modal.module"
	],
	"./notification/notification.module": [
		"./src/app/theme/ui-elements/advance/notification/notification.module.ts",
		"notification.module"
	],
	"./notify/notify.module": [
		"./src/app/theme/ui-elements/advance/notify/notify.module.ts",
		"common",
		"notify.module"
	],
	"./paging/paging.module": [
		"./src/app/theme/table/data-table/paging/paging.module.ts",
		"paging.module"
	],
	"./pre-loader/pre-loader.module": [
		"./src/app/theme/ui-elements/basic/pre-loader/pre-loader.module.ts",
		"pre-loader.module"
	],
	"./progressbar/progressbar.module": [
		"./src/app/theme/ui-elements/basic/progressbar/progressbar.module.ts",
		"progressbar.module"
	],
	"./radial/radial.module": [
		"./src/app/theme/chart/radial/radial.module.ts",
		"common",
		"radial.module"
	],
	"./rating/rating.module": [
		"./src/app/theme/ui-elements/advance/rating/rating.module.ts",
		"rating.module"
	],
	"./registration/registration.module": [
		"./src/app/theme/auth/registration/registration.module.ts",
		"registration.module"
	],
	"./row-details/row-details.module": [
		"./src/app/theme/table/data-table/row-details/row-details.module.ts",
		"row-details.module"
	],
	"./selection/selection.module": [
		"./src/app/theme/table/data-table/selection/selection.module.ts",
		"selection.module"
	],
	"./sizing/sizing.module": [
		"./src/app/theme/table/bootstrap-table/sizing/sizing.module.ts",
		"sizing.module"
	],
	"./social-header-footer-login/social-header-footer-login.module": [
		"./src/app/theme/auth/login/social-header-footer-login/social-header-footer-login.module.ts",
		"social-header-footer-login.module"
	],
	"./social-header-footer-reg/social-header-footer-reg.module": [
		"./src/app/theme/auth/registration/social-header-footer-reg/social-header-footer-reg.module.ts",
		"social-header-footer-reg.module"
	],
	"./social-login/social-login.module": [
		"./src/app/theme/auth/login/social-login/social-login.module.ts",
		"social-login.module"
	],
	"./social-reg/social-reg.module": [
		"./src/app/theme/auth/registration/social-reg/social-reg.module.ts",
		"social-reg.module"
	],
	"./statistic/statistic.module": [
		"./src/app/theme/widget/statistic/statistic.module.ts",
		"common",
		"statistic.module"
	],
	"./styling/styling.module": [
		"./src/app/theme/table/bootstrap-table/styling/styling.module.ts",
		"styling.module"
	],
	"./table-basic-data/table-basic-data.module": [
		"./src/app/theme/table/data-table/table-basic-data/table-basic-data.module.ts",
		"table-basic-data.module"
	],
	"./table-basic/table-basic.module": [
		"./src/app/theme/table/bootstrap-table/table-basic/table-basic.module.ts",
		"table-basic.module"
	],
	"./table-edit/table-edit.module": [
		"./src/app/theme/table/data-table/table-edit/table-edit.module.ts",
		"table-edit.module"
	],
	"./tabs/tabs.module": [
		"./src/app/theme/ui-elements/basic/tabs/tabs.module.ts",
		"tabs.module"
	],
	"./task-board/task-board.module": [
		"./src/app/theme/task/task-board/task-board.module.ts",
		"task-board.module"
	],
	"./task-details/task-details.module": [
		"./src/app/theme/task/task-details/task-details.module.ts",
		"common",
		"task-details.module"
	],
	"./task-issue/task-issue.module": [
		"./src/app/theme/task/task-issue/task-issue.module.ts",
		"task-issue.module"
	],
	"./task-list/task-list.module": [
		"./src/app/theme/task/task-list/task-list.module.ts",
		"task-list.module"
	],
	"./theme/auth/auth.module": [
		"./src/app/theme/auth/auth.module.ts",
		"auth.module"
	],
	"./theme/chart/chart.module": [
		"./src/app/theme/chart/chart.module.ts",
		"chart.module"
	],
	"./theme/dashboard/dashboard.module": [
		"./src/app/theme/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./theme/extension/file-upload-ui/file-upload-ui.module": [
		"./src/app/theme/extension/file-upload-ui/file-upload-ui.module.ts",
		"file-upload-ui.module"
	],
	"./theme/extension/invoice/invoice.module": [
		"./src/app/theme/extension/invoice/invoice.module.ts",
		"invoice.module"
	],
	"./theme/forms/forms.module": [
		"./src/app/theme/forms/forms.module.ts",
		"forms.module"
	],
	"./theme/maintenance/coming-soon/coming-soon.module": [
		"./src/app/theme/maintenance/coming-soon/coming-soon.module.ts",
		"coming-soon.module"
	],
	"./theme/maintenance/error/error.module": [
		"./src/app/theme/maintenance/error/error.module.ts",
		"error.module"
	],
	"./theme/maintenance/offline-ui/offline-ui.module": [
		"./src/app/theme/maintenance/offline-ui/offline-ui.module.ts",
		"offline-ui.module"
	],
	"./theme/map/map.module": [
		"./src/app/theme/map/map.module.ts",
		"map.module"
	],
	"./theme/navigation/navigation.module": [
		"./src/app/theme/navigation/navigation.module.ts",
		"navigation.module"
	],
	"./theme/simple-page/simple-page.module": [
		"./src/app/theme/simple-page/simple-page.module.ts",
		"simple-page.module"
	],
	"./theme/table/bootstrap-table/bootstrap-table.module": [
		"./src/app/theme/table/bootstrap-table/bootstrap-table.module.ts",
		"bootstrap-table.module"
	],
	"./theme/table/data-table/data-table.module": [
		"./src/app/theme/table/data-table/data-table.module.ts",
		"data-table.module"
	],
	"./theme/task/task.module": [
		"./src/app/theme/task/task.module.ts",
		"task.module"
	],
	"./theme/ui-elements/advance/advance.module": [
		"./src/app/theme/ui-elements/advance/advance.module.ts",
		"advance.module"
	],
	"./theme/ui-elements/animation/animation.module": [
		"./src/app/theme/ui-elements/animation/animation.module.ts",
		"animation.module"
	],
	"./theme/ui-elements/basic/basic.module": [
		"./src/app/theme/ui-elements/basic/basic.module.ts",
		"basic.module"
	],
	"./theme/user/user.module": [
		"./src/app/theme/user/user.module.ts",
		"user.module"
	],
	"./theme/widget/widget.module": [
		"./src/app/theme/widget/widget.module.ts",
		"widget.module"
	],
	"./tooltip/tooltip.module": [
		"./src/app/theme/ui-elements/basic/tooltip/tooltip.module.ts",
		"tooltip.module"
	],
	"./typography/typography.module": [
		"./src/app/theme/ui-elements/basic/typography/typography.module.ts",
		"typography.module"
	],
	"./user-card/user-card.module": [
		"./src/app/theme/user/user-card/user-card.module.ts",
		"user-card.module"
	],
	"./user-profile/user-profile.module": [
		"./src/app/theme/user/user-profile/user-profile.module.ts",
		"user-profile.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main